import '../app.ts'
import '/@front:css/views/account.login.css'

import { useForm } from 'laravel-precognition-vue'
import { createApp } from 'vue'

createApp({
  name: 'forgot-password',
  setup() {
    const form = useForm('post', location.pathname, {
      email: '',
    })

    return {
      form,
    }
  },
}).mount('#main-content')
